import { render, staticRenderFns } from "./CampaignView.vue?vue&type=template&id=08b9ee84&"
import script from "./CampaignView.vue?vue&type=script&lang=js&"
export * from "./CampaignView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports